<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
<div >
    <v-subheader class="subtitle-1 whitesmoke font-weight-medium grayBold--text">
      {{ $t("device_info") }}
    </v-subheader>
    <v-list class="whitesmoke tab" min-width="500px">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="overline grayBold--text">
              {{ $t("device_friendly_name_uppercase") }}
            </v-list-item-title>
            <v-list-item-subtitle class="pt-1 grayBold--text"> {{device.info.device_name ?? '-'}} </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title class="overline grayBold--text">
              {{ $t("notes_uppercase") }}
            </v-list-item-title>
            <v-list-item-subtitle class="pt-1 grayBold--text"> {{device.info.notes ?? '-'}} </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
    </v-list>
    <v-divider class="mx-4 "/>
    <v-subheader class="subtitle-1 whitesmoke font-weight-medium grayBold--text">
      {{ $t("installation_info") }}
    </v-subheader>
    <v-list class="whitesmoke tab" min-width="500px">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="overline grayBold--text">
              {{ $t("address_uppercase") }}
            </v-list-item-title>
            <v-list-item-subtitle class="pt-1 grayBold--text"> {{device.info.address ?? '-'}} </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title class="overline grayBold--text">
              {{ $t("area_uppercase") }}
            </v-list-item-title>
            <v-list-item-subtitle class="pt-1 grayBold--text"> {{device.info.area ?? '-'}} </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mx-4 mt-2"/>
        <div class="d-flex justify-space-between">
            <div class="justify-space-between pt-5" width="50%">
                <v-subheader class="subtitle-1 font-weight-medium grayBold--text">
                {{ $t("tenant_info") }}
                </v-subheader>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                    {{ $t("fullname_uppercase") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> 
                      {{ device.info.client_firstname ? device.info.client_firstname + ' ' + device.info.client_lastname : '-'}}
                    </v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
                <v-divider class="mx-4 mt-2"/>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                    {{ $t("email") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> {{ device.info.client_email ? device.info.client_email : '-'}} </v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
                <v-divider class="mx-4 mt-2"/>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                    {{ $t("phone_uppercase") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> 
                      {{ device.info.client_phone ? device.info.client_phone : '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </div>
            <div class="justify-space-between pt-5" width="50%">
                <v-subheader class="subtitle-1 font-weight-medium grayBold--text">
                {{ $t("installer_info") }}
                </v-subheader>
                <v-list-item>
                  <v-list-item-content>
                      <v-list-item-title class="overline grayBold--text">
                      {{ $t("company_name_uppercase") }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="pt-1 grayBold--text"> 
                        {{ device.info.comp_name ? device.info.comp_name : '-'}}
                      </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                      <v-list-item-title class="overline grayBold--text">
                      {{ $t("company_contact_person") }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="pt-1 grayBold--text"> 
                        {{ device.info.comp_contact_name ? device.info.comp_contact_name : '-'}}
                      </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mx-4 mt-2"/>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                    {{ $t("email") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> {{ device.info.comp_email ? device.info.comp_email : '-'}} </v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
                <v-divider class="mx-4 mt-2"/>
                <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                    {{ $t("phone_uppercase") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> 
                      {{ device.info.comp_contact ? device.info.comp_contact : '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </div>
        </div>
    </v-list>
    </div>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'

@Component
export default class DevicesSideviewInfoTab extends Vue {
 @Prop() device: Record<string, any>;

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
